if (!customElements.get('editable-faq-showcase')) {
  class EditableFaqShowcase extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.items = [...this.querySelectorAll('[data-efaq-item]')];
      this.toggleButton = this.querySelector('[data-efaq-toggle]');
      this.visibleCount = Math.max(1, Number.parseInt(this.dataset.visibleCount || '4', 10));
      this.isExpanded = false;

      if (this.toggleButton && this.items.length > this.visibleCount) {
        this.toggleButton.hidden = false;
        this.toggleButton.addEventListener('click', () => this.toggleItems());
        this.updateItems();
      }

      this.addEventListener('toggle', (event) => this.handleDetailsToggle(event), true);
      this.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event));
    }

    toggleItems() {
      const allowCollapse = this.dataset.allowCollapse === 'true';
      if (this.isExpanded && !allowCollapse) return;

      this.isExpanded = !this.isExpanded;
      this.updateItems();
      if (this.isExpanded && !allowCollapse) {
        this.items[this.visibleCount]?.querySelector('summary')?.focus({ preventScroll: true });
      }
    }

    updateItems() {
      this.items.forEach((item, index) => {
        const shouldHide = !this.isExpanded && index >= this.visibleCount;
        item.hidden = shouldHide;

        if (shouldHide && item.open) item.open = false;
      });

      if (!this.toggleButton) return;

      const allowCollapse = this.dataset.allowCollapse === 'true';
      this.toggleButton.hidden = this.isExpanded && !allowCollapse;
      this.toggleButton.closest('.efaq__more').hidden = this.toggleButton.hidden;
      this.toggleButton.setAttribute('aria-expanded', String(this.isExpanded));
      this.toggleButton.textContent = this.isExpanded
        ? this.toggleButton.dataset.lessLabel
        : this.toggleButton.dataset.moreLabel;
    }

    handleDetailsToggle(event) {
      const openedItem = event.target;
      if (!(openedItem instanceof HTMLDetailsElement)) return;
      if (!openedItem.matches('[data-efaq-item]') || !openedItem.open) return;
      if (this.dataset.singleOpen !== 'true') return;

      this.items.forEach((item) => {
        if (item !== openedItem) item.open = false;
      });
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element)) return;
      const selectedItem = event.target.closest('[data-efaq-item]');
      if (!selectedItem || !this.contains(selectedItem)) return;

      const selectedIndex = this.items.indexOf(selectedItem);
      if (selectedIndex >= this.visibleCount) {
        this.isExpanded = true;
        this.updateItems();
      }

      selectedItem.open = true;
    }
  }

  customElements.define('editable-faq-showcase', EditableFaqShowcase);
}
